import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
import icons from './icons';
import { useTelemetry } from '../internal/hooks/use-telemetry';
export default function Icon(_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'normal' : _b, _c = _a.variant, variant = _c === void 0 ? 'normal' : _c, url = _a.url, alt = _a.alt, props = __rest(_a, ["name", "size", "variant", "url", "alt"]);
    useTelemetry('Icon');
    var baseProps = getBaseProps(props);
    baseProps.className = clsx(baseProps.className, styles.icon, styles["size-" + size], styles["variant-" + variant]);
    if (url) {
        return (React.createElement("span", __assign({}, baseProps),
            React.createElement("img", { src: url, alt: alt })));
    }
    // dangerouslySetInnerHTML is safe here, as we control the content coming from `icons`
    // eslint-disable-next-line react/no-danger
    return React.createElement("span", __assign({}, baseProps, { dangerouslySetInnerHTML: name ? { __html: icons[name] } : undefined }));
}
//# sourceMappingURL=index.js.map